import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../Tabels/Tabels.css";
import plus from "../../../Components/Admin/assets/icons/a1.png";
import colunms from "../../../Components/Admin/assets/icons/LINES.png";
import search1 from "../../../Components/Admin/assets/icons/search.png";
import top from "../../../Components/Admin/assets/icons/top.png";
import Table from "react-bootstrap/Table";
import { Link } from "react-router-dom";
import Header from "../Header/Header";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faRotate, fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import toast, { Toaster } from "react-hot-toast";
// import AddOffCanvance from "./Add";
// import EditOffCanvance from "./Edit";
// import ModalDelete from "../../../common/ModalDelete";
import { AddButton, EditButton, DeletButton } from "../../common/Button";
import Pagination_Holder from "../../Common _Components/Pagination_Holder/Pagination_Holder";
import Pagination from "react-bootstrap/Pagination";
import {
  Container,
  Row,
  Col,
  Button,
  Form,
  InputGroup,
  Modal,
} from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
library.add(fas);

// *****************************************************************************************************

const Tables = () => {
  const {
    getData,
    editStatusData,
    deleteData,
    ErrorNotify,
    isAllow,
    Per_Page_Dropdown,
    postData,
    Select2Data,
  } = useContext(Context);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },

    watch,
    getValues,
  } = useForm();

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setperPage] = useState(5);
  const [search, setSearch] = useState("");
  const [email, setEmail] = useState("");
  const [contact_no, setContact_no] = useState("");
  const [reset, setReset] = useState();
  const [show, setShowAdd] = useState(false);
  const [show1, setShowEdit] = useState(0);
  const [changeStatus, setChangeStatus] = useState();
  const [option, setOption] = useState();

  const [totalPages, settotalPages] = useState();

  const [onPageChange, setonPageChange] = useState(1);

  const [searchWithdrawStatus, setsearchWithdrawStatus] = useState("");

  const handlePageChange = (pageNumber) => {
    console.log(pageNumber, "pageNumber");

    setonPageChange(pageNumber);
  };

  const paginationItems = [];
  for (let page = 1; page <= totalPages; page++) {
    paginationItems.push(
      <Pagination.Item
        key={page}
        active={page === onPageChange}
        onClick={() => handlePageChange(page)}
      >
        {page}
      </Pagination.Item>
    );
  }

  const ChangeStage = async (id, appr) => {
    const response = await postData(
      `/masters/wallet-request/request/${id}`,
      appr
    );
    setChangeStatus(response);
  };

  const getDataAll = async () => {
    const response = await getData(
      `/masters/wallet-request?page=${onPageChange}&per_page=${perPage}&term=${search}&withdraw_status=${
        searchWithdrawStatus?.value || ""
      }`
    );
    await setData(response);
    setCurrentPage(response?.data?.currentPage);
    setperPage(response?.data?.per_page);
    setSearch(response?.data?.search_name);
    setEmail(response?.data?.email);
    setContact_no(response?.data?.contact_no);
    settotalPages(response?.data?.totalPages);
    setOption(await Per_Page_Dropdown(response?.data?.totalEntries));

    const newData = response?.data?.data;
    if (newData) {
      const newIds = newData.map((d) => d?.id);
      setAllChecked(newIds);
    }
  };

  useEffect(() => {
    getDataAll();
  }, [changeStatus, perPage, reset, show, show1, onPageChange]);

  const [withdrawStatus, setWithdrawStatus] = useState([]);

  const GetAllWithdrawStatus = async () => {
    const response = await getData(
      "/without-login/all-withdraw-status-for-admin"
    );
    if (response?.success) {
      setWithdrawStatus(
        await Select2Data(response?.data, "withdraw_status_id")
      );
    }
  };

  useEffect(() => {
    GetAllWithdrawStatus();
  }, []);

  // Select All Functionality
  const [selectAllChecked, setSelectAllChecked] = useState([]);
  const [allChecked, setAllChecked] = useState([]);

  const handleSelectAll = async () => {
    await setSelectAllChecked(allChecked);
  };

  const handleChange = async (e) => {
    const { value, checked } = e.target;

    if (value === "selectAll") {
      if (checked) {
        handleSelectAll();
      } else {
        await setSelectAllChecked([]);
      }
    } else {
      if (checked) {
        await setSelectAllChecked([...selectAllChecked, Number(value)]);
      } else {
        await setSelectAllChecked(
          selectAllChecked.filter((e) => e !== Number(value))
        );
      }
    }
  };

  // Delete module
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [recordToDeleteId, setRecordToDeleteId] = useState(null);
  const [recordToDeleteName, setRecordToDeleteName] = useState(null);

  const showDeleteRecord = async (id, name) => {
    setShowDeleteModal(true);
    setRecordToDeleteId(id);
    setRecordToDeleteName(name);
  };

  const handleDeleteRecord = async () => {
    setShowDeleteModal(false);
    if (recordToDeleteId) {
      const response = await deleteData(`/masters/users/${recordToDeleteId}`);

      ErrorNotify(recordToDeleteName);

      setRecordToDeleteId(null);
      setRecordToDeleteName(null);
      setChangeStatus(response);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
    setRecordToDeleteId(null);
    setRecordToDeleteName(null);
  };

  //  column hide and show.....
  const [visible, setVisibel] = useState({
    col0: true,
    col1: true,
    col2: true,
    col3: true,
    col4: true,
    col5: true,
    col6: true,
    col7: true,
    col8: true,
    col9: true,
    col10: true,
    col11: true,
    col12: true,
  });

  //toggle columnns.........
  const toggleColumn = (event, columnName) => {
    event.preventDefault();
    setVisibel((prev) => ({
      ...prev,
      [columnName]: !prev[columnName],
    }));
  };

  const [view, setview] = useState(0);
  const handleViewClose = () => setview(false);
  const handleViewshow = async (id) => {
    await setview(id);
  };

  return (
    <>
      <div className="Dashboard">
        <Header title={"Wallet Withdrawal Request"} link={"/wallet-request"} />
        <section className="Advancemain-advancedashboard">
          <div className="col-xxl-12 col-xl-12  ">
            <section className="Tabels tab-radio tab-radio mt-5">
              <div className="">
                <div className="row">
                  <div className="d-flex">
                    <div className="add me-3"></div>
                  </div>
                  <div className="border-line mt-3"></div>
                  <div className="row mt-4">
                    <div className=" col-xxl-3 col-xl-12 col-lg-12 col-md-12 col-12">
                     
                    </div>
                    <div className="col-xxl-9   col-xl-12 col-lg-12  col-md-12 col-12">
                      <div className="d-flex justify-content-end">
                        <div className="sowing me-2">
                          <p className="show mt-2">{`Showing ${Math.min(
                            (currentPage - 1) * perPage + 1
                          )} to ${Math.min(
                            currentPage * perPage,
                            data?.data?.totalEntries
                          )} of ${data?.data?.totalEntries} entries`}</p>
                        </div>
                        <div className="num me-2">
                          <input
                            type="text"
                            className="form-control"
                            id=""
                            placeholder="User Name/Contact No"
                            value={search}
                            onChange={(e) => {
                              setSearch(e.target.value);
                            }}
                          />
                        </div>

                        <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-6 col-12 mb-2">
                          <div className="num ">
                            <Select
                              isSearchable
                              options={withdrawStatus}
                              value={searchWithdrawStatus}
                              placeholder="Select Status "
                              onChange={(e) => {
                                setsearchWithdrawStatus(e);

                                handlePageChange(1);
                              }}
                            />
                          </div>
                        </div>

                        <div className="Search ms-2 me-2">
                          <button
                            type="button"
                            onClick={getDataAll}
                            className="btn btn-search"
                          >
                            <img src={search1} className="search" alt="" />
                          </button>
                        </div>

                        <div className="Search-1">
                          <button
                            type="button"
                            onClick={() => {
                              setSearch("");
                              setContact_no("");
                              setEmail("");
                              setsearchWithdrawStatus("");
                              setReset(!reset);
                            }}
                            className="btn btn-reset"
                          >
                            <FontAwesomeIcon icon={faRotate} />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="border-line mt-3"></div>
                <div className="row mt-3">
                  <div className="data table-responsive">
                    <Table striped bordered hover responsive center>
                      <thead>
                        <tr className="">
                          {visible.col1 && (
                            <th className="tax-name">Sr. No.</th>
                          )}
                          {visible.col2 && (
                            <th className="tax-name"> User Type </th>
                          )}{" "}
                          {visible.col3 && (
                            <th className="tax-name">User Name</th>
                          )}{" "}
                          {visible.col4 && (
                            <th className="tax-name">User Contact Number</th>
                          )}{" "}
                          {visible.col5 && <th className="tax-name">Amount</th>}
                          {visible.col6 && (
                            <th className="tax-name">Account Number </th>
                          )}{" "}
                          {visible.col7 && (
                            <th className="tax-name">IFSC Code </th>
                          )}{" "}
                          {visible.col8 && (
                            <th className="tax-name" style={{ width: "110px" }}>
                              UPI Id
                            </th>
                          )}{" "}
                          {visible.col11 && (
                            <th className="tax-name" style={{ width: "110px" }}>
                              Withdrawl Date
                            </th>
                          )}
                          {visible.col12 && (
                            <th className="tax-name" style={{ width: "110px" }}>
                              Withdrawl Time
                            </th>
                          )}
                          {visible.col10 && (
                            <th className="active">Action/Status</th>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {data?.data?.data?.length > 0 ? (
                          data?.data?.data?.map((d, index) => {
                            const paginatedIndex =
                              (onPageChange - 1) * perPage + index + 1;
                            return (
                              <tr className="" key={index}>
                                {visible.col1 && <td>{paginatedIndex}.</td>}{" "}
                                {visible.col2 && (
                                  <td>
                                    {d?.user?.type == "Driver"
                                      ? "Driver"
                                      : "Customer"}
                                  </td>
                                )}
                                {visible.col3 && <td>{d?.user?.f_name}</td>}
                                {visible.col4 && <td>{d?.user?.contact_no}</td>}
                                {visible.col5 && <td>{d?.amount}</td>}
                                {visible.col6 && (
                                  <td>{d?.account_no || "-"}</td>
                                )}
                                {visible.col7 && <td>{d?.ifsc_code || "-"}</td>}
                                {visible.col8 && <td>{d?.upi_id || "-"}</td>}
                                {visible.col11 && (
                                  <td>
                                    {d?.createdAt
                                      ? new Date(d.createdAt).toLocaleString(
                                          "en-GB",
                                          {
                                            day: "2-digit",
                                            month: "long",
                                            year: "numeric",
                                          }
                                        )
                                      : "N/A"}
                                  </td>
                                )}
                                {visible.col12 && (
                                  <td>
                                    {d?.createdAt
                                      ? new Date(d.createdAt).toLocaleString(
                                          "en-GB",
                                          {
                                            hour: "2-digit",
                                            minute: "2-digit",
                                            hour12: true,
                                          }
                                        )
                                      : "N/A"}
                                  </td>
                                )}
                                {visible.col10 && (
                                  <td>
                                    {d?.withdraw_status_id != 2 ? (
                                      d?.withdraw_status?.name
                                    ) : (
                                      <Col md={6}>
                                        <div className="main-form-section mt-3">
                                          <Form.Group>
                                            <Form.Label>
                                              Take an action
                                            </Form.Label>
                                            <InputGroup>
                                              <Controller
                                                name={`stage-${index}`}
                                                control={control}
                                                rules={{
                                                  required: "Take an Action",
                                                }}
                                                render={({
                                                  field,
                                                  fieldState: { error },
                                                }) => (
                                                  <>
                                                    <Select
                                                      {...field}
                                                      styles={{
                                                        control: (
                                                          baseStyles
                                                        ) => ({
                                                          ...baseStyles,
                                                          borderColor: error
                                                            ? "red"
                                                            : baseStyles.borderColor,
                                                        }),
                                                        menuPortal: (base) => ({
                                                          ...base,
                                                          zIndex: 9999,
                                                        }),
                                                      }}
                                                      onChange={(
                                                        selectedOption
                                                      ) => {
                                                        field.onChange(
                                                          selectedOption
                                                        );
                                                        ChangeStage(
                                                          d.id,
                                                          selectedOption
                                                        );
                                                      }}
                                                      options={[
                                                        {
                                                          value: 1,
                                                          label: "Approved",
                                                        },
                                                        {
                                                          value: 3,
                                                          label: "Rejected",
                                                        },
                                                      ]}
                                                      isDisabled={
                                                        d.stage === "Rejected"
                                                      }
                                                    />
                                                    {error && (
                                                      <p className="error-message">
                                                        {error.message}
                                                      </p>
                                                    )}
                                                  </>
                                                )}
                                              />
                                            </InputGroup>
                                          </Form.Group>
                                        </div>
                                      </Col>
                                    )}
                                  </td>
                                )}
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td
                              colSpan={12}
                              style={{
                                textAlign: "center",
                                verticalAlign: "middle",
                                padding: "20px",
                              }}
                            >
                              No data available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>{" "}
                    <Pagination_Holder
                      onPageChange={currentPage}
                      totalPages={totalPages}
                      handlePageChange={handlePageChange}
                    />
                  </div>
                </div>
              </div>
            </section>
          </div>
        </section>
      </div>

      {/* {show ? (
        <AddOffCanvance
          handleClose={handleClose}
          setShow={setShowAdd}
          show={show}
        />
      ) : (
        ""
      )}

      {show1 ? (
        <EditOffCanvance
          handleClose={handleClose1}
          setShow={setShowEdit}
          show={show1}
        />
      ) : (
        ""
      )}
      <ModalDelete
        show={showDeleteModal}
        handleDeleteRecord={handleDeleteRecord}
        handleDeleteCancel={handleDeleteCancel}
      /> */}
      <Toaster position="top-right" />
    </>
  );
};

export default Tables;
